import { render, staticRenderFns } from "./KPIItem.vue?vue&type=template&id=ee5e4da6&scoped=true&"
import script from "./KPIItem.vue?vue&type=script&lang=js&"
export * from "./KPIItem.vue?vue&type=script&lang=js&"
import style0 from "./KPIItem.vue?vue&type=style&index=0&id=ee5e4da6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee5e4da6",
  null
  
)

export default component.exports